<app-common-dropdown
    [formCtrl]="formCtrl"
    [label]="label || 'Выбрать группу'"
    [service]="groupSelectorService"
    [noneOption]="noneOption"
    [multiple]="multiple"
    [selectAllButton] = true
    data-testid="group-select"
></app-common-dropdown>
